// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_e1-0";
export var fileCarousel = "_e1-2";
export var removeFileButton = "_e1-1";